import {
  APP_COLOR,
  FONT_FAMILY,
} from "../../theme";


export const styles = {
  libraryContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "0px 10px 5px 10px",
    fontFamily: FONT_FAMILY,
    margin: "40px 0",
  } as const,
  linearProgressContainer: {
    width: "100%",
    color: APP_COLOR,
    height: "50vh",
    paddingTop: 20,
  } as const,
};
